<template>
  <div>
    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Mensuração de anúncios</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="equal-height-row">
            <v-col cols="12" md="6" class="px-0 d-flex flex-column">
              <mf-toggle v-model="overrideFacebookPixel" label="Sobrescrever configuração de Pixel Facebook" class="pl-5" hide-details />
              <ads-pixel-facebook-configuration v-model="facebookPixelValue" :disabled="!overrideFacebookPixel" class="flex-grow-1" />
            </v-col>
            <v-col cols="12" md="6" class="px-0 d-flex flex-column">
              <mf-toggle v-model="overrideGoogleAnalytics" label="Sobrescrever configuração de Google Analytics" class="pl-5" hide-details />
              <ads-google-analytics-configuration v-model="googleAnalyticsValue" :disabled="!overrideGoogleAnalytics" class="flex-grow-1" />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Tags de cadastro</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="equal-height-row">
            <v-col cols="12" md="6" class="px-0 d-flex flex-column">
              <generic-configuration-card v-model="signupTag" title="Tag de cadastro">
                <template #description>
                  Todos os cadastros feitos através do site deste site de cadastramento serão marcados com a tag informada aqui. Com isso, será possível
                  segmentar os clientes cadastrados através do motor de segmentação da Mercafacil. Caso a tag seja alterada, os próximos cadastros serão
                  marcados com a tag nova, enquanto os cadastros já realizados continuarão com a tag antiga.
                </template>
              </generic-configuration-card>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'HotsiteConfigurationAdvanced',
  components: {
    AdsPixelFacebookConfiguration: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/AdsPixelFacebookConfiguration.vue'),
    AdsGoogleAnalyticsConfiguration: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/AdsGoogleAnalyticsConfiguration.vue'),
    GenericConfigurationCard: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/GenericConfigurationCard.vue'),
  },
  data: () => ({}),
  computed: {
    ...mapGetters('hotsiteConfiguration', ['currentConfiguration']),
    overrideFacebookPixel: {
      get() {
        return this.currentConfiguration?.overrides?.facebook_pixel_id !== null && this.currentConfiguration?.overrides?.facebook_pixel_id !== undefined
      },
      set(value) {
        if (!value) {
          // When disabling override, set to null
          this.updateOverrides({
            facebook_pixel_id: null,
          })
        } else {
          // When enabling override, set to empty string if not already set
          const currentValue = this.currentConfiguration?.overrides?.facebook_pixel_id
          if (currentValue === null || currentValue === undefined) {
            this.updateOverrides({
              facebook_pixel_id: '',
            })
          }
        }
      },
    },
    overrideGoogleAnalytics: {
      get() {
        return this.currentConfiguration?.overrides?.google_analytics_id !== null && this.currentConfiguration?.overrides?.google_analytics_id !== undefined
      },
      set(value) {
        if (!value) {
          // When disabling override, set to null
          this.updateOverrides({
            google_analytics_id: null,
          })
        } else {
          // When enabling override, set to empty string if not already set
          const currentValue = this.currentConfiguration?.overrides?.google_analytics_id
          if (currentValue === null || currentValue === undefined) {
            this.updateOverrides({
              google_analytics_id: '',
            })
          }
        }
      },
    },
    facebookPixelValue: {
      get() {
        return this.overrideFacebookPixel ? this.currentConfiguration?.overrides?.facebook_pixel_id || '' : ''
      },
      set(value) {
        this.updateOverrides({
          facebook_pixel_id: value,
        })
      },
    },
    googleAnalyticsValue: {
      get() {
        return this.overrideGoogleAnalytics ? this.currentConfiguration?.overrides?.google_analytics_id || '' : ''
      },
      set(value) {
        this.updateOverrides({
          google_analytics_id: value,
        })
      },
    },
    signupTag: {
      get() {
        return this.currentConfiguration?.overrides?.signup_tag || ''
      },
      set(value) {
        this.updateOverrides({
          signup_tag: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('hotsiteConfiguration', ['updateOverrides']),
  },
}
</script>

<style lang="scss" scoped>
.equal-height-row {
  .v-col {
    display: flex;
    align-items: stretch;
  }
}
</style>
